document.querySelectorAll('.service-modal').forEach((dialog) => {
	dialog.addEventListener('click', (event) => {
		if (event.target === dialog) {
			dialog.close();
		}
	});
});